import React from "react";
import styled from "styled-components";
import { Modal, Row, Col, Card, Button } from "antd";
import { CustomLabel } from "../../../../Common/style";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import "./appointmentModal.css";

const YesButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 130px;
  height: 50px;
  border-radius: 40px;
  border: solid 0.5px #f26221;
  margin-top: 10px;
  text-align: center;
  background-image: ${(props) =>
    props.disable ? "" : "linear-gradient(to top, #f26221, #f5851f)"};
  .ant-btn-text[disabled] {
    color: #f26221 !important;
    font-weight: bold;
  }
  .ant-btn-text {
    color: white !important;
    font-weight: bold;
  }
  &:hover {
    background-image: linear-gradient(to top, #f26221, #f5851f);
    .ant-btn-text[disabled] {
      color: white !important;
      font-weight: bold;
    }
  }
  @media (max-width: 768px) {
    width: 90px;
    height: 35px;
    border-radius: 17.5px;
    padding: 12px 2px;
    .ant-btn-text[disabled] {
      font-size: 11px;
    }
    .ant-btn-text {
      font-size: 11px;
    }
  }
`;

const CancelButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 130px;
  height: 50px;
  border-radius: 40px;
  border: solid 2px #f47720;
  margin-top: 10px;
  margin-right: 20px;
  text-align: center;
  .ant-btn-text[disabled] {
    color: #f26221 !important;
    font-weight: bold;
  }
  .ant-btn-text {
    color: #f47720 !important;
    font-weight: bold;
  }
  &:hover {
    .ant-btn-text[disabled] {
      color: #f47720 !important;
      font-weight: bold;
    }
  }
  @media (max-width: 768px) {
    width: 90px;
    height: 35px;
    border-radius: 17.5px;
    padding: 12px 2px;
    .ant-btn-text[disabled] {
      font-size: 11px;
    }
    .ant-btn-text {
      font-size: 11px;
    }
  }
`;

const renderProceedBooking = (
  email,
  mobile,
  date,
  time,
  language,
  onCancel,
  onClickYes,
  isInstantSelected
) => {
  return (
    <Card>
      <Row gutter={[20, 0]}>
        <Col md={24} className="title">
          <CustomLabel font_size="20" font_weight="bold">
            {`Do you want to proceed with ${
              isInstantSelected ? "Instant" : "Scheduled"
            } Call?`}
          </CustomLabel>
        </Col>
        {isInstantSelected && (
          <Col xs={24} md={24}>
            <CustomLabel
              font_size="14"
              font_weight="normal"
            >
              {"Note: You will receive call in next 30 minutes."}
            </CustomLabel>
          </Col>
        )}
      </Row>
      <Row className="content-row" gutter={[20, 20]}>
        {!isInstantSelected ? (
          <>
            <Col xs={12} md={8}>
              <Row>
                <Col xs={24}>
                  <CustomLabel font_size="14" font_weight="bold">
                    {"Date"}
                  </CustomLabel>
                </Col>
                <div className="justify-flex-center h-25">
                  <Col xs={2}>
                    <span className="start_icon" style={{ fontSize: "16px" }}>
                      <i
                        className="fa fa-calendar-check-o"
                        aria-hidden="true"
                      ></i>
                    </span>
                  </Col>
                  <Col xs={22}>
                    <CustomLabel
                      className="ml-3"
                      font_size="14"
                      font_weight="normal"
                    >
                      {date}
                    </CustomLabel>
                  </Col>
                </div>
              </Row>
            </Col>
            <Col xs={12} md={8}>
              <Row>
                <Col xs={24}>
                  <CustomLabel font_size="14" font_weight="bold">
                    {"Time"}
                  </CustomLabel>
                </Col>
                <div className="justify-flex-center h-25">
                  <Col xs={2}>
                    <span className="start_icon" style={{ fontSize: "18px" }}>
                      <i className="fa fa-clock-o" aria-hidden="true"></i>
                    </span>
                  </Col>
                  <Col xs={22}>
                    <CustomLabel
                      className="ml-3"
                      font_size="14"
                      font_weight="normal"
                    >
                      {`${time?.hour}:${time?.minute} ${time?.meridiem}`}
                    </CustomLabel>
                  </Col>
                </div>
              </Row>
            </Col>
          </>
        ) : null}
        <Col xs={12} md={8}>
          <Row>
            <Col xs={24}>
              <CustomLabel font_size="14" font_weight="bold">
                {"Language"}
              </CustomLabel>
            </Col>
            <div className="justify-flex-center h-25">
              <Col xs={2}>
                <span className="start_icon" style={{ fontSize: "18px" }}>
                  <i className="fa fa-language" aria-hidden="true"></i>
                </span>
              </Col>
              <Col xs={22}>
                <CustomLabel
                  className="ml-3"
                  font_size="14"
                  font_weight="normal"
                >
                  {language || "NA"}
                </CustomLabel>
              </Col>
            </div>
          </Row>
        </Col>
        <Col xs={12} md={8}>
          <Row>
            <Col xs={24}>
              <CustomLabel font_size="14" font_weight="bold">
                {"Mobile Number"}
              </CustomLabel>
            </Col>
            {mobile && (
              <div className="justify-flex-center h-25">
                <Col xs={2}>
                  <span className="start_icon" style={{ fontSize: "24px" }}>
                    <i className="fa fa-mobile" aria-hidden="true"></i>
                  </span>
                </Col>
                <Col xs={22}>
                  <CustomLabel
                    className="ml-2"
                    font_size="14"
                    font_weight="normal"
                  >
                    {mobile || "NA"}
                  </CustomLabel>
                </Col>
              </div>
            )}
          </Row>
        </Col>
        <Col xs={12} md={12}>
          <Row>
            <Col xs={24}>
              <CustomLabel font_size="14" font_weight="bold">
                {"Email ID"}
              </CustomLabel>
            </Col>
            <div className="display-contents h-25">
              <Col xs={2}>
                <span className="start_icon" style={{ fontSize: "16px" }}>
                  <i className="fa fa-envelope" aria-hidden="true"></i>
                </span>
              </Col>
              <Col xs={22}>
                <div className="ml-3">
                  <CustomLabel font_size="14" font_weight="normal">
                    {email || "NA"}
                  </CustomLabel>
                </div>
              </Col>
            </div>
          </Row>
        </Col>
      </Row>
      <Row className="modal-btn-wrapper">
        <Col xs={24}>
          <div className="justify-flex-center">
            <CancelButton disable={false}>
              <Button onClick={onCancel} type="text" disabled={false}>
                {"CANCEL"}
                <FontAwesomeIcon icon={faAngleRight} className="right-icon" />
              </Button>
            </CancelButton>
            <YesButton disable={false}>
              <Button onClick={onClickYes} type="text" disabled={false}>
                {"YES"}
                <FontAwesomeIcon icon={faAngleRight} className="right-icon" />
              </Button>
            </YesButton>
          </div>
        </Col>
      </Row>
    </Card>
  );
};

const AppointmentModal = ({
  open,
  onClose,
  email,
  mobile,
  date,
  time,
  language,
  onBooking,
  isInstantSelected
}) => {

  return (
    <Modal
      style={{ top: 20 }}
      open={open}
      onCancel={onClose}
      closable={false}
      destroyOnClose
      zIndex="999"
      footer={null}
    >
      <div className="modal-wrapper">
        {renderProceedBooking(
          email,
          mobile,
          date,
          time,
          language,
          onClose,
          onBooking,
          isInstantSelected
        )}
      </div>
    </Modal>
  );
};

export default AppointmentModal;
